// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1s-xA","inputDescription":"styles_inputDescription__EzCfx"};